import { render, staticRenderFns } from "./top-case-base-info.vue?vue&type=template&id=12986fcc&scoped=true"
import script from "./top-case-base-info.vue?vue&type=script&lang=ts"
export * from "./top-case-base-info.vue?vue&type=script&lang=ts"
import style0 from "./top-case-base-info.vue?vue&type=style&index=0&id=12986fcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12986fcc",
  null
  
)

export default component.exports